"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$t = exports.translateTextNode = exports.translateTextWithParams = exports.translateText = exports.translateMessage = void 0;
var LogMessageDataType_1 = require("../LogMessageDataType");
var PreferencesManager_1 = require("../components/PreferencesManager");
var raw_translations = require("../genfiles/translations.json");
var TM_translations = raw_translations;
function translateMessage(message) {
    return translateText(message.message).replace(/\$\{(\d{1,2})\}/gi, function (_match, idx) {
        if (message.data[idx] !== undefined && message.data[idx].type === LogMessageDataType_1.LogMessageDataType.RAW_STRING) {
            return message.data[idx].value;
        }
        return '';
    });
}
exports.translateMessage = translateMessage;
function translateText(englishText) {
    var translatedText = englishText;
    var lang = PreferencesManager_1.PreferencesManager.load('lang') || 'en';
    if (lang === 'en')
        return englishText;
    englishText = normalizeText(englishText);
    var languages = TM_translations[englishText];
    if (languages !== undefined && languages[lang] !== undefined) {
        translatedText = languages[lang];
    }
    else {
        var stripedText = englishText.replace(/^\((.*)\)$/gm, '$1');
        if (stripedText && stripedText !== englishText) {
            stripedText = translateText(stripedText);
            if (stripedText !== englishText) {
                translatedText = '(' + stripedText + ')';
            }
        }
        else if (stripedText && stripedText.length > 3) {
            console.log('Please translate "' + stripedText + '"');
        }
    }
    return translatedText;
}
exports.translateText = translateText;
function translateTextWithParams(englishText, params) {
    var data = params.map(function (p) {
        return {
            type: LogMessageDataType_1.LogMessageDataType.RAW_STRING,
            value: p,
        };
    });
    var message = {
        message: englishText,
        data: data,
    };
    return translateMessage(message);
}
exports.translateTextWithParams = translateTextWithParams;
function normalizeText(text) {
    return text.replace(/[\n\r]/g, '').replace(/[ ]+/g, ' ').trim();
}
function translateChildren(node) {
    for (var i = 0, length_1 = node.childNodes.length; i < length_1; i++) {
        var child = node.childNodes[i];
        if (child.nodeType === Node.TEXT_NODE) {
            var text = child;
            var translatedText = translateText(text.data);
            if (translatedText !== text.data) {
                text.data = translatedText;
            }
        }
        else {
            translateChildren(child);
        }
    }
}
function translateTextNode(el) {
    translateChildren(el);
}
exports.translateTextNode = translateTextNode;
var $t = function (msg) {
    if (!msg)
        return '';
    if (typeof (msg) === 'number')
        return msg.toString();
    if (typeof msg === 'string') {
        return translateText(msg);
    }
    return translateMessage(msg);
};
exports.$t = $t;
//# sourceMappingURL=i18n.js.map